import * as CL from '@design-system/component-library';
import { FormProvider, useForm } from 'react-hook-form';
import { dsClass } from '../../common/constants/dsClasses.js';
import { businessIdMsg, nextMsg, t } from '../../common/i18n/index.js';
import { CompanySearch } from '../../common/react-hook-form/fields/index.js';
import type { Company } from '../../generated/api/models.js';

export interface RegistrationStep1Props {
  isEditable?: boolean;
  persistedCompany?: Company;
  storeCompany: (company: Company) => void;
}

const CompanyDetailsElement = (company: Company) => {
  return (
    <div>
      <h4>{company.name}</h4>
      <div id="of-registration-step1-business-id">
        {t.MPA5(businessIdMsg)}: <strong>{company.businessId}</strong>
      </div>
      <div id="of-registration-step1-company-address">
        {company.postalAddress}
        {company.postalAddress && (company.postCode || company.postOffice) && ', '}
        {company.postCode}
        {company.postOffice && ` ${company.postOffice}`}
      </div>
    </div>
  );
};

export const RegistrationCompanyForm = ({ persistedCompany, storeCompany }: RegistrationStep1Props) => {
  const methods = useForm({ mode: 'all', defaultValues: persistedCompany });
  const company = methods.watch();

  return (
    <div className="of-registration-step of-registration-scene-step1">
      <FormProvider {...methods}>
        <form
          onSubmit={methods.handleSubmit(values => {
            storeCompany(values);
          })}
          noValidate
        >
          <p>{t.HJ9V('Corporate account can be created by a person who is authorized to do that.')}</p>
          <CompanySearch
            fieldNames={{
              businessId: 'businessId',
              businessName: 'name',
              masterId: 'masterId',
              postalAddress: 'postalAddress',
              postCode: 'postCode',
              postOffice: 'postOffice',
            }}
          />
          {company?.businessId && (
            <>
              <CompanyDetailsElement {...company} />
              <div className={dsClass.PADDING_TOP_4}>
                <CL.Button size="l" type="submit">
                  {t.F0MY(nextMsg)}
                </CL.Button>
              </div>
            </>
          )}
        </form>
      </FormProvider>
    </div>
  );
};

export const RegistrationStep1 = ({ isEditable, persistedCompany, storeCompany }: RegistrationStep1Props) => {
  if (!isEditable) {
    return <>{persistedCompany && <CompanyDetailsElement {...persistedCompany} />}</>;
  }
  return <RegistrationCompanyForm persistedCompany={persistedCompany} storeCompany={storeCompany} />;
};
